import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD}`

const fetchCarteraCliente = (query) => http.get(`${api}/operacion/cartera-proveedor`, { params: { ...query } })

export {
  fetchCarteraCliente
}
